/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'scripts';
const componentName = 'data-script-clone-dialog';
const prefix = `${moduleName}.${componentName}`;

export const cloneDataScriptDialogHeader = `${prefix}.cloneDataScriptDialogHeader`;
export const closeButtonLabel = `${prefix}.closeButtonLabel`;
export const cloneButtonLabel = `${prefix}.cloneButtonLabel`;
export const dataScriptNameLabel = `${prefix}.dataScriptNameLabel`;

export const ENGLISH = {
    [cloneDataScriptDialogHeader]: 'Clone DataScript',
    [closeButtonLabel]: 'Close',
    [cloneButtonLabel]: 'Clone',
    [dataScriptNameLabel]: 'DataScript Name',
};
